import React from "react";
import { useTranslation } from "react-i18next";
import {
  EmailBuilderBoundedRange,
  EmailBuilderColorOverrideField,
} from "../../shell/panel/blockSettings/EmailBuilderBlockSettingsShared";
import { DEFAULT_IMAGE_OVERLAY } from "../../domain/image-overlay";
import type { ImageOverlay } from "../../domain/types";
import { EmailBuilderSettingsToggleField } from "./EmailBuilderSettingsToggleField";

type EmailBuilderSettingsImageOverlayFieldsProps = {
  value: ImageOverlay;
  onChange: (overlay: ImageOverlay) => void;
};

export function EmailBuilderSettingsImageOverlayFields({
  value,
  onChange,
}: EmailBuilderSettingsImageOverlayFieldsProps) {
  const { t } = useTranslation();
  const resolved = value ?? DEFAULT_IMAGE_OVERLAY;
  const hasColorOverride = resolved.color !== DEFAULT_IMAGE_OVERLAY.color;

  return (
    <>
      <EmailBuilderSettingsToggleField
        label={t("Image overlay")}
        checked={resolved.enabled}
        onChange={enabled =>
          onChange({
            ...resolved,
            enabled,
          })
        }
      />
      {resolved.enabled ? (
        <>
          <EmailBuilderColorOverrideField
            label={t("Overlay color")}
            color={resolved.color}
            hasOverride={hasColorOverride}
            showFieldLabel
            onChange={color =>
              onChange({
                ...resolved,
                color,
              })
            }
            onReset={() =>
              onChange({
                ...resolved,
                color: DEFAULT_IMAGE_OVERLAY.color,
              })
            }
          />
          <EmailBuilderBoundedRange
            label={t("Overlay opacity")}
            value={resolved.opacity}
            min={0}
            max={100}
            defaultValue={DEFAULT_IMAGE_OVERLAY.opacity}
            onChange={opacity => {
              if (opacity === undefined) {
                return;
              }
              onChange({
                ...resolved,
                opacity,
              });
            }}
          />
        </>
      ) : null}
    </>
  );
}
